const f = {
  color: {
    background: "#ffffffff",
    mask: {
      border: "#abb9c7ff",
      disabled: "#7e8e9eff",
      focused: "rgba(197, 208, 217, 0.5)",
      regular: "#314351ff",
      placeholder: {
        regular: "#7e8e9eff",
        disabled: "#7e8e9eff",
        border: {
          regular: "#abb9c7ff",
          hover: "#304ddbff"
        }
      }
    },
    input: {
      regular: "#314351ff",
      placeholder: "#7e8e9eff"
    },
    label: "#abb9c7ff",
    floatingLabel: "#abb9c7ff",
    focusIndicator: {
      active: "#304ddbff",
      inactive: "#c6d0d8",
      default: "#4176faff",
      error: "#e54a32ff",
      warning: "#fabf5aff"
    },
    invisible: "transparent",
    closeButton: {
      regular: "#7e8e9eff",
      hover: "#314351ff",
      delete: "#e54a32ff"
    },
    addButton: {
      bg: {
        default: "#f1f3f5ff",
        hover: "#304ddbff",
        focus: "#304ddbff",
        disabled: "#f1f3f5ff"
      },
      color: {
        default: "#7e8e9eff",
        hover: "#fff",
        focus: "#fff",
        disabled: "#c6d0d8"
      }
    },
    options: {
      icon: {
        hover: "#7e8e9eff",
        active: "#314351ff"
      }
    }
  }
};
export {
  f as editableField
};
